import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

import { formatDate } from "@punto/frontend-shared/utils/date/format-date";
import { toLowerCase } from "@punto/frontend-shared/utils/to-lower-case";

interface FormatDateOptions {
  format?: string;
}

const defaultLng = "es";

export const initI18n = (buildVersion: string) => {
  const backendParams = buildVersion && {
    queryStringParams: { v: buildVersion },
  };

  void i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      lng: defaultLng,
      defaultNS: "translation",
      fallbackLng: defaultLng,
      interpolation: {
        escapeValue: false,
      },
      backend: {
        loadPath: "/locales/{{lng}}/{{ns}}.json",
        ...backendParams,
      },
      react: {
        useSuspense: false,
      },
    });

  i18n.services?.formatter?.add?.("lowercase", (value: string) =>
    toLowerCase(value),
  );

  i18n.services?.formatter?.add?.(
    "date",
    (value: string, lng, options: FormatDateOptions) => {
      return formatDate(value, { format: options.format, lng });
    },
  );

  return i18n;
};
